<script>
export default {
  name: 'BaseDialog',
}
</script>

<template>
  <v-dialog
    width="90vw"
    max-width="522px"
    transition="scale-transition"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </v-dialog>
</template>
